
import React from 'react';
import { useDispatch } from 'react-redux';

import keepConnectionGetActions from '../sagas/keepConnection';

export default function useKeepConnection(urls) {

    const dispatch = useDispatch();
    const keepConnectionActions = keepConnectionGetActions(dispatch);

    React.useEffect(() => {
        keepConnectionActions.keepConnectionStart(urls);
    });
}
